import React, { Component } from "react";
import MetaHelmet from "../utils/MetaHelmet";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { Device } from "../utils/Device";
import { logout, showLogin } from "../user/UserActions";
import "./Homepage.scss";
import ContentSlider from '../ui/ContentSlider';
import Root from "../layout/Root";
import { AppState } from "../RootReducer";
import { getCasinoCategory } from "../actions/CasinoCategoryActions";
import { CasinoCategoryDispatchTypes, TopGames, PlayAgainGames, NewGames, MostPopularGames, CasinoGameCategory } from "../actions/CasinoCategoryActions";
import { getContainer } from "../ioc/IOCSetup";
import Banner from "../ui/Banner"
import { ContentModelName, HomePayload, GlobalPayload, SlidersMaharajaPayload } from "../contenful/types";
import { throws } from "assert";
import { fetchContent } from "../contenful/ContentfulActions";
import { Dispatch } from "redux";
import { CasinoLobby, CasinoGame, UserInfo } from "../http/protocol";
import { CasinoState, CasinoStatus } from "../casino/CasinoReducer";
import { loadCasinoGames, selectCategory } from "../casino/CasinoActions";

import { LiveCasinoState, LiveCasinoStatus } from "../livecasino/LiveCasinoReducer";
import { addPlayedGame, loadLiveCasinoGames, toggleFavouriteGame } from "../livecasino/LiveCasinoActions";
import { Link } from "react-router-dom";

import { t } from "../i18n";
import HomeAdsSlider from "../ui/HomeAdsSlider";


interface dispatchProps {
    showLogin: () => void;


}

let homeAds1 = [
    {
        link:"/promotions/new-year-esportes",
        image: "https://content.adminemx.com/joiabet/promotions/Esportes_Joia_1800x330px.jpg?v=1",
        },  
    {
        link:"/promotions/explosao-de-ano-novo",
        image: "https://content.adminemx.com/joiabet/promotions/AnoNovo_JoiaBet_1800x330px.jpg?v=1",
        },  
    {
    linkOutside:"https://t.me/joiabetpromos",
    image: "https://content.adminemx.com/joiabet/promotions/JoiaBet_Telegram_1800x330.jpg?v=1",
    },  
    {
        link:"/promotions/boas-vindas-esportes",
        image: "https://content.adminemx.com/joiabet/promotions/1800x330-JoiaBet_Sports.jpg",
    }, 
    {
        link:"/promotions/crash-game-bonus",
        image: "https://content.adminemx.com/joiabet/Sliders/1800x330-Crash-Games.jpg",
    }, 
    {
    link:"/promotions/casino-welcome-bonus",
    image: "https://content.adminemx.com/joiabet/Sliders/1800x330-DM.jpg?v=1",
    },  
    {
        link:"/casino/33/crash-games",
        image: "https://content.adminemx.com/joiabet/Sliders/JoiaBet_Crash_1800x330px.jpg",
    }, 

   
]

let homeAds2 = [
    {
        link:"/promotions/explosao-de-ano-novo",
        image: "https://content.adminemx.com/joiabet/promotions/AnoNovo_JoiaBet_1800x330px.jpg?v=1",
        }, 
    {
        link:"/promotions/new-year-esportes",
        image: "https://content.adminemx.com/joiabet/promotions/Esportes_Joia_1800x330px.jpg?v=1",
        },  
    
    {

        link:"/promotions/casino-welcome-bonus",
        image: "https://content.adminemx.com/joiabet/Sliders/1800x330-DM.jpg?v=1",
        },  
        {
            link:"/promotions/crash-game-bonus",
            image: "https://content.adminemx.com/joiabet/Sliders/1800x330-Crash-Games.jpg",
        }, 
        {
            link:"/promotions/boas-vindas-esportes",
            image: "https://content.adminemx.com/joiabet/promotions/1800x330-JoiaBet_Sports.jpg",
        }, 
        {
            link:"/casino/33/crash-games",
            image: "https://content.adminemx.com/joiabet/Sliders/JoiaBet_Crash_1800x330px.jpg",
        }, 
]

let homeAds3 = [
    {
        link:"/promotions/explosao-de-ano-novo",
        image: "https://content.adminemx.com/joiabet/promotions/AnoNovo_JoiaBet_1800x330px.jpg?v=1",
        }, 
    {
        link:"/promotions/new-year-esportes",
        image: "https://content.adminemx.com/joiabet/promotions/Esportes_Joia_1800x330px.jpg?v=1",
        },  
    {

        link:"/promotions/casino-welcome-bonus",
        image: "https://content.adminemx.com/joiabet/Sliders/1800x330-DM.jpg?v=1",
        },  
        {
            link:"/promotions/boas-vindas-esportes",
            image: "https://content.adminemx.com/joiabet/promotions/1800x330-JoiaBet_Sports.jpg",
        }, 
        {
            link:"/casino/33/crash-games",
            image: "https://content.adminemx.com/joiabet/Sliders/JoiaBet_Crash_1800x330px.jpg",
        }, 
        {
            link:"/promotions/crash-game-bonus",
            image: "https://content.adminemx.com/joiabet/Sliders/1800x330-Crash-Games.jpg",
        }, 
]
interface State {
    hideAfterWentToOtherPage: boolean;
    animate: boolean;
    promotionbanner?: any;
}
interface Props {
    topGames: TopGames,
    newGames: NewGames,
    playAgainGames: PlayAgainGames,
    mostPopularGames: MostPopularGames,
    cats: CasinoGameCategory,
    banners: any,
    getCasinoCategory: () => void;
    loadLiveCasinoGames?: () => void
    isloggedIn: boolean;
    lng: string;
    homepage: HomePayload;
    fetchContent: typeof fetchContent;
    isFetching?: boolean;
    slidersMaharaja?: SlidersMaharajaPayload;
    loadCasinoGames?: () => void;
    lobby?: CasinoLobby;
    optInBonusPlans?: any;
    status?: CasinoStatus;
    popularLiveGames: NewGames;
    vivaBrazil:NewGames;
    crashGames: NewGames;
    user?: UserInfo;
}
type AllProps = Props & dispatchProps;

export class HomePageV2 extends Component<AllProps, State> {

    constructor(props: AllProps) {
        super(props);

        this.state = {
            animate: false,
            hideAfterWentToOtherPage: false,
        }


    }

    componentDidMount() {
        this.props.getCasinoCategory();
        let promotions = getContainer().getSettingsService().getPromotions();
        let homepromo = promotions && promotions.filter(function (obj: any) {
            return obj.placement.includes("HOME") && obj.isEnabled;
        })
        this.setState({ promotionbanner: homepromo })

        // eslint-disable-next-line
        getContainer().getSettingsService().getActiveLocale().code;

        if (this.props.status != CasinoStatus.DONE) {
            this.props.loadCasinoGames && this.props.loadCasinoGames();
            this.props.loadLiveCasinoGames && this.props.loadLiveCasinoGames();
        }



        if (!this.props.isFetching) {

            if (this.props.homepage === undefined) {
                this.props.fetchContent(ContentModelName.HOME, getContainer().getSettingsService().getActiveLocale().code);
            }
            if (this.props.slidersMaharaja === undefined) {
                this.props.fetchContent(ContentModelName.SLIDERSMAHARAJA, getContainer().getSettingsService().getActiveLocale().code);
            }
        }

    }


    renderLandingPageBanner() {

    }

    render() {

        const title: string = t("meta.homePage.title") || "";
        const subtitle: string = t("meta.homePage.subtitle") || "";
        const fullTitle: string = t("meta.homePage.fullTitle") || "";
        const description: string = t("meta.homePage.description") || "";
        const keywords: string = t("meta.homePage.keywords") || "";
        const baserHref: string = t("meta.homePage.keywords") || "";

        return (

            <Root footer={true} header={true}>

                {MetaHelmet(title, fullTitle, description, keywords)}


                <section id="home" className="iq-main-slider p-0">
                    <div id="home-slider" className="slider m-0 p-0">
                        {/* {this.props.banners ? <Banner data={this.props.banners} loggedIn={this.props.isloggedIn} showLogin={()=>this.props.showLogin()} lng={this.props.lng} /> : null} */}
                        {this.state.promotionbanner ? <Banner data={this.state.promotionbanner} optInBonusPlans={this.props.optInBonusPlans} loggedIn={this.props.isloggedIn} user={this.props.user} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}
                    </div>
                </section>
                {/* Main Content */}
                <div className="home-content">
                    <section id="iq-upcoming-movie" className="s-margin">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12 ">
                                    <div className="iq-main-header d-flex align-items-center justify-content-between">

                                        <h4 className="main-title"><img src="https://content.adminemx.com/maharajafortune/images/header-icons-v2/live-casino.svg" className="icon-home"/>{t("homePageTexts.popularLiveGames")} <a className="btn btn-secondary btn-sm btn-thin red-bg" href="/livecasino/45/popular-live%20games">{t("homePageTexts.viewMore")}</a></h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="upcoming-contens">
                        {this.props.popularLiveGames ? <ContentSlider  themev2={true} slides={this.props.popularLiveGames} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}

                        </div>

                    </section>

                    <section id="iq-favorites" className="s-margin">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12 ">
                                    <div className="iq-main-header d-flex align-items-center justify-content-between">

                                        <h4 className="main-title"><img src="https://content.adminemx.com/joiabet/icons/crash-games.svg" className="icon-home"/>{t("homePageTexts.crashGames")} <a className="btn btn-secondary btn-sm btn-thin red-bg" href={"/casino/33/crash-games"}>{t("homePageTexts.viewMore")}</a></h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="favorites-contens">
                        {this.props.crashGames ? <ContentSlider  themev2={true} slides={this.props.crashGames} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}

                        </div>

                    </section>
                    {/* Home Ads */}
                    <div className="suggestede-contens">
                            {homeAds1 ? <HomeAdsSlider slides={homeAds1} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}
                        </div>
                  {/* Home Ads */}

                    <section id="iq-suggestede" className="s-margin">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12 ">
                                    <div className="iq-main-header d-flex align-items-center justify-content-between">

                                        <h4 className="main-title"><img src="https://content.adminemx.com/joiabet/icons/viva-brazil.svg" className="icon-home"/>{t("homePageTexts.vivaBrazil")} </h4>

                                    </div>
                                </div>
                            </div>

                        </div>
                        
                        <div className="suggestede-contens">
                            {this.props.vivaBrazil ? <ContentSlider themev2={true} slides={this.props.vivaBrazil} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}
                        </div>


                    </section>
                    {/* Home Ads */}
                    <div className="suggestede-contens">
                            {homeAds2 ? <HomeAdsSlider slides={homeAds2} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}
                        </div>
                  {/* Home Ads */}
                    <section id="iq-mostpopular" className="s-margin">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-12 ">
                                    <div className="iq-main-header d-flex align-items-center justify-content-between">

                                        <h4 className="main-title"><img src="https://content.adminemx.com/joiabet/icons/new.svg" className="icon-home"/>{t("homePageTexts.newRelease")}  <a className="btn btn-secondary btn-sm btn-thin red-bg" href="/casino/15/new-games">{t("homePageTexts.viewMore")}</a></h4>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="suggestede-contens">
                            {this.props.newGames ? <ContentSlider  themev2={true} slides={this.props.newGames} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}

                        </div>

                    </section>
                    
                    


                    
                        {/* Home Ads */}
                        <div className="suggestede-contens">
                            {homeAds3 ? <HomeAdsSlider slides={homeAds3} loggedIn={this.props.isloggedIn} showLogin={() => this.props.showLogin()} lng={this.props.lng} /> : null}
                        </div>
                      {/* Home Ads */}


                    




                </div>

            </Root>

        )
    }

}

const mapStateToProps = (casinoCat: AppState) => {
    let newGames: CasinoGame[] = [];
    let allNewGames = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : newGames;

    newGames = allNewGames.filter(g => g.Tags?.includes("isHomeNewGamesBR"));


    let homeTopGames: CasinoGame[] = [];
    let allTopGames = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : homeTopGames;
    homeTopGames = allTopGames.filter(g => g.Tags?.includes("isHomeTopGames"));

    let homeMostPopular: CasinoGame[] = [];
    let allMostGames = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : homeMostPopular;

    homeMostPopular = allMostGames.filter(g => g.Tags?.includes("isHomePopularGames"));

    let homeRecommended: CasinoGame[] = [];
    let allRecommendedGames = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : homeMostPopular;

    homeRecommended = allRecommendedGames.filter(g => g.Tags?.includes("isHomeRecommended"));


    let isHomeCrashGames: CasinoGame[] = [];
    let allHomeCrashGames = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : isHomeCrashGames;

    isHomeCrashGames = allHomeCrashGames.filter(g => g.Tags?.includes("isHomeCrashGamesBR"));


    let isHomePopularLiveGames: CasinoGame[] = [];
    let allHomePopularLiveGames = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : isHomePopularLiveGames;

    isHomePopularLiveGames = allHomePopularLiveGames.filter(g => g.Tags?.includes("IsHomePopularLiveGamesBR"));

    let isHomeVivaBrazil: CasinoGame[] = [];
    let allHomeVivaBrazil = casinoCat.casino.lobby && casinoCat.casino.lobby.games ? casinoCat.casino.lobby.games : isHomePopularLiveGames;

    isHomeVivaBrazil = allHomeVivaBrazil.filter(g => g.Tags?.includes("isHomeVivaBrazil"));



    return {
        status: casinoCat.casino.status,
        optInBonusPlans: casinoCat.user.optInBonusPlans,
        topGames: homeTopGames,
        vivaBrazil:isHomeVivaBrazil,
        playAgainGames: homeRecommended,
        newGames: newGames,
        mostPopularGames: homeMostPopular,
        crashGames: isHomeCrashGames,
        popularLiveGames: isHomePopularLiveGames,
        cats: casinoCat.casinoCat.casinoCategory !== undefined ? casinoCat.casinoCat.casinoCategory.category : undefined,
        banners: casinoCat.casinoCat.casinoCategory !== undefined ? casinoCat.casinoCat.casinoCategory.banner : undefined,
        isloggedIn: casinoCat.user.user && casinoCat.user.user.loggedIn,
        user: casinoCat.user.user,
        lng: getContainer().getSettingsService().getActiveLocale().code,
        isFetching: casinoCat.contentful.isFetching,
        homepage: casinoCat.contentful.home,
        slidersMaharaja: casinoCat.contentful.slidersMaharaja,
    }
};


const mapDispatchToProps = (dispatch: Dispatch) => ({
    showLogin: () => dispatch(showLogin(true)),
    getCasinoCategory: () => dispatch(getCasinoCategory() as any),
    fetchContent: (contentModelName: ContentModelName, locale?: string) => dispatch(fetchContent(contentModelName, locale) as any),
    loadCasinoGames: () => dispatch(loadCasinoGames() as any),
    loadLiveCasinoGames: () => dispatch(loadLiveCasinoGames() as any),
});


export default connect(mapStateToProps, mapDispatchToProps)(HomePageV2 as any);